import { render } from "./AddWithdrawalAddress.vue?vue&type=template&id=eb325e22&scoped=true"
import script from "./AddWithdrawalAddress.vue?vue&type=script&lang=js"
export * from "./AddWithdrawalAddress.vue?vue&type=script&lang=js"

import "./AddWithdrawalAddress.vue?vue&type=style&index=0&id=eb325e22&lang=less&scoped=true"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb325e22"]])

export default __exports__